import { H3 } from '@h3/types';
import { request } from '@h3/request';
import * as Api from './constant';
/** 消息发送方 */
export const getDataSpeakUser = () => {
    return request<H3.Http.Response.H3Response<string[]>>(Api.getDataSpeakUser, {
        method: H3.Http.MethodType.GET,
    });
};

export const getDataSpeakLicense = () => {
    return request<
        H3.Http.Response.H3Response<{
            version: number | null;
            effectiveEndTime: string | null;
            quantity: number;
            usedCount: number;
            effectiveStartTime: string | null;
        }>
    >(Api.getDataSpeakLicense, {
        method: H3.Http.MethodType.GET,
    });
};
export const checkDataSpeakUserAuthorization = (params: { userId: string }) => {
    // success 校验通过
    // plugin.notexist 未安装插件
    // param.invalid userId为空
    // dataspeak.license.fetch_failed 获取订单失败
    // dataspeak.license.not_found 无有效订单
    // dataspeak.license.expired 订单已过期
    // dataspeak.license.invalid_end_time 订单到期时间无效
    // dataspeak.auth.user_not_authorized 指定用户未授权
    // dataspeak.auth.fetch_failed 获取授权用户失败
    return request<H3.Http.Response.H3Response<string>>(Api.checkDataSpeakUserAuthorization, {
        method: H3.Http.MethodType.GET,
        params,
    });
};
